import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CouponStripe } from '../models/coupon-stripe.model';

export type PlanCheckoutData = {
  priceId: string;
  successUrl: string;
  cancelUrl: string;
  coupon?: string;
}

export type TokenPackCheckoutData = {
  priceId: string;
  successUrl: string;
  cancelUrl: string;
  coupon?: string;
}

@Injectable({
  providedIn: 'root'
})
export class StripeCheckoutService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  checkCoupon(couponCode: string): Observable<CouponStripe> {
    const url = `${environment.apiUrl}/stripe/check-coupon/${couponCode}`;
    return this.http.post<CouponStripe>(url, {});
  }

  checkoutPlan(priceId: string, couponCode?: string): void {
    let planCheckoutData: PlanCheckoutData = {
      priceId: priceId,
      successUrl: `${environment.websiteUrl}/dashboard/payment-success`,
      cancelUrl: `${environment.websiteUrl}/dashboard/payment-error`
    }
    if (couponCode) planCheckoutData.coupon = couponCode;
    this.http.post(`${environment.apiUrl}/stripe/subcription-checkout`, planCheckoutData)
      .subscribe({
        next: (checkoutResponse: any) => {
          window.location = checkoutResponse.url
        },
        error: (error: HttpErrorResponse) => {
          const statusError: number = error.status;
          if (statusError === 401) {
            this.router.navigate(['/login'])
          } else {
            console.error(error)
          }
        },
      });
  }

  checkoutTokensPack(priceId: string, couponCode?: string): void {
    const tokensCheckoutData: TokenPackCheckoutData = {
      priceId: priceId,
      successUrl: `${environment.websiteUrl}/dashboard/payment-success`,
      cancelUrl: `${environment.websiteUrl}/dashboard/payment-error`
    }

    if(couponCode) tokensCheckoutData.coupon = couponCode;
    this.http.post(`${environment.apiUrl}/stripe/individual-token-checkout`, tokensCheckoutData)
      .subscribe({
        next: (checkoutResponse: any) => {
          window.location = checkoutResponse.url
        },
        error: (error: HttpErrorResponse) => {
          const statusError: number = error.status;
          if (statusError === 401) {
            this.router.navigate(['/login'])
          } else {
            console.error(error)
          }
        },
      });
  }
}
